import classNames from 'classnames';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Editor } from 'slate';
import { useSlate } from 'slate-react';
import { RichTextBoxToolbarButtonBaseProps } from '../richTextEditorTypes';

function getIcon(icon: JSX.Element | JSX.Element[] | string[] | string | null | undefined) {
    if (!icon)
        return null;
    if (React.isValidElement(icon)) {
        return icon;
    }
    const icons = (Array.isArray(icon) ? icon : [icon]).map((mapIcon, index) => {
        if (React.isValidElement(mapIcon)) {
            return mapIcon;
        }
        if (typeof mapIcon === 'string')
            return <i className={mapIcon} key={index}></i>
        return null;
    });
    return icons;
}



type RichTextBoxToolbarButtonProps = RichTextBoxToolbarButtonBaseProps & {
    isActive: boolean
};

export const InternalButton = React.forwardRef((
    props: RichTextBoxToolbarButtonProps,
    ref: React.ForwardedRef<HTMLButtonElement>
) => {
    const { isActive, attrs, icon } = props;
    const { className, title, onClick, disable, ...trimmedAttrs } = attrs ?? { className: undefined, disable: undefined };
    const activeClass = !isActive ? "btn-seconary btn-outline-primary" : "btn-primary btn-outline-primary text-secondary";
    const editor = useSlate();
    const treatedTitle = useMemo(() => {
        if (title) {
            if (typeof title === 'string') {
                const lines = title.split('\n');
                return (<>
                    {lines.map((value, index) => <span key={index}>{value}<br /></span>)}
                </>)
            }
        }
        return (<span>{title}</span>);
    }, [title]);

    const iconElement = useMemo(() => {
        return getIcon(icon);
    }, [icon]);


    const isDisabled = useMemo(() => {

        return Boolean(editor.selection) && Boolean(Editor.marks(editor)?.isMacroSearch && !disable);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editor, editor.selection, disable])


    return (
        <OverlayTrigger placement='bottom' overlay={
            <Tooltip>
                {
                    treatedTitle && treatedTitle
                }
            </Tooltip>
        }>
            <button ref={ref} disabled={isDisabled} className={classNames('richtextbox-toolbar-button btn', activeClass, className)} {...trimmedAttrs} onClick={(e) => {
                if (onClick) {
                    onClick(e);
                    e.preventDefault();
                    return false;
                }
                return false;
            }}>
                {iconElement}
                {
                    Boolean(props.label) && (
                        <label>{props.label}</label>
                    )
                }
            </button>
        </OverlayTrigger>
    )
});
InternalButton.displayName = 'ToolbarButton';


export const RichTextBoxToolbarButton = observer(InternalButton);
